import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { successSchema } from '../utils';
import { ZFeedbackInsert } from './models';

const c = initContract();
export const publicFeedbackContract = c.router(
  {
    sendFeedback: {
      method: 'POST',
      path: '/feedback',
      body: ZFeedbackInsert.pick({
        action: true,
        feedback: true,
        playerId: true,
        refId: true,
      }),
      responses: {
        200: successSchema,
        400: z.object({
          message: z.string(),
        }),
      },
    },
  },
  {
    pathPrefix: '/public',
  },
);
